export const capitalize = (string: string) => string && string[0].toUpperCase() + string.slice(1).toLowerCase();
export const capitalizeFirst = (string: string) => string && string[0].toUpperCase() + string.slice(1);
